import * as React from 'react';

import { InjectedRouter } from 'react-router';

// @ts-ignore
import PromptActions from 'actions/PromptActions';
import { withRouter } from 'app/context/Router';
// @ts-ignore
import View from 'components/View';
import { PromptNames } from 'constants/PromptConstants';
// @ts-ignore
import PromptStore from 'stores/PromptStore';
import LinkDevicePage from 'user/components/LinkDevicePage';

type Props = {
  router: InjectedRouter;
  location: any;
};

class SetupSmsDevice extends React.Component<Props> {
  componentDidMount() {
    if (!PromptStore.hasDismissed(PromptNames.NUX_SETUP_SMS_DEVICE)) {
      PromptActions.recordDismissal(PromptNames.NUX_SETUP_SMS_DEVICE);
    }
  }

  onDone = () => {
    this.props.router.push(this.props.location?.state?.location ?? '/');
  };

  render() {
    return (
      <View>
        <LinkDevicePage onDone={this.onDone} onSkip={this.onDone} deviceType="phoneNumber" />
      </View>
    );
  }
}

export { SetupSmsDevice };

export default withRouter(SetupSmsDevice);
